// src/onboarding/OnboardingGate.jsx
//
// The post-login prompt (decisions 2–4). Renders nothing. Once the store describes the ACTIVE
// workspace and its state prompts, it redirects to the wizard — once per (workspace, login), and
// ⛔ ONLY from a default landing (never a Stripe return, an email link, a bookmark).
// Covers every entry path (login, picker, invitation accept, a reload / new tab) because it
// OBSERVES state instead of hooking login() / selectTenant(): boot never navigates.
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.jsx';
import { useOnboarding } from './onboardingStore.js';
import { shouldPrompt, PERSONALIZATION_PATH } from './onboardingModel.js';
import { hasPrompted, markPrompted, tokenKey } from './onboardingStorage.js';

export default function OnboardingGate() {
  const { activeTenant, token } = useAuth();
  const snapshot = useOnboarding();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const tenantId = activeTenant?.tenant_id || null;

  useEffect(() => {
    if (!shouldPrompt(snapshot, tenantId, pathname)) return;
    const loginKey = tokenKey(token);
    if (hasPrompted(tenantId, loginKey)) return;
    // Marked WHEN it redirects, not when the wizard is completed — so Skip needs to write nothing.
    markPrompted(tenantId, loginKey);
    navigate(PERSONALIZATION_PATH);
  }, [snapshot, tenantId, pathname, token, navigate]);

  return null;
}
